// removed by extract-text-webpack-plugin
module.exports = {"SimpleModal":"Simple-cssmodule-SimpleModal-1ZoXN","title":"Simple-cssmodule-title-1USGj","contentView":"Simple-cssmodule-contentView-dzfny","content":"Simple-cssmodule-content-2q6p8","description":"Simple-cssmodule-description-Q7V0z","media":"Simple-cssmodule-media-3R2Bx","button":"Simple-cssmodule-button-2kTyE","cancelButton":"Simple-cssmodule-cancelButton-1pQMD"};


//////////////////
// WEBPACK FOOTER
// ./themes/LineTheme/Simple.cssmodule.less
// module id = 695
// module chunks = 0